import React from 'react';
import { useHistory } from "react-router-dom";
import {Box, Grid, Button, Link} from '@material-ui/core';
import axios from 'axios';
import LoadingButton from '@mui/lab/LoadingButton';
// import Radio from '@mui/material/Radio';
// import RadioGroup from '@mui/material/RadioGroup';
// import FormControlLabel from '@mui/material/FormControlLabel';
// import FormControl from '@mui/material/FormControl';
// import FormLabel from '@mui/material/FormLabel';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import TextField from '@mui/material/TextField';
import {MetaTags} from 'react-meta-tags';
import {API_URL} from '../utils/EnvVars';
import '../styles/bizofficer-a.css';
import 'font-awesome/css/font-awesome.min.css';
import Cookies from 'js-cookie';
// import { useDispatch } from 'react-redux';
// import { addUser } from '../store/user.actions';
// import { selectCourse } from '../store/course.actions';
// import { setMyCourses } from '../store/mycourses.actions';
// import { setTopicTree, setTopicList, setKeywordList, setTopicTreeLearning, setTopicListLearning, setKeywordListLearning, setTopicTreeTest, setTopicListTest, setSmartLearning, setMockTest } from '../store/data.actions';




  export default function Execute() {	
	let history = useHistory();
	var otpLoginJson = localStorage.getItem('otploginjson');
	const [otpNumber, setOtpNumber] = React.useState("");
	const [showAlert, setShowAlert] = React.useState(false);
	const [alertMessage, setAlertMessage] = React.useState("");


	var vertical='top',horizontal='center';

	function hideAlert(){
		setShowAlert(false);
	}

	function verify(){
		///alert('Login Now');
		if(!otpNumber){
			setShowAlert(true);
			setAlertMessage("Enter your otp.");			
			return false;

		}else{ // Login with OTP *************************
			document.getElementById('waitloginbtnid').style.display='';
			document.getElementById('loginbtnid').style.display='none';
			let axiosHeader = {
				headers: {
					'Content-Type': 'multipart/mixed',
				}
			};		  

			var lgnObj = JSON.parse(otpLoginJson);
			const data = new FormData();
			data.append('otpNumber', otpNumber);
			data.append('token', lgnObj.token);		
			data.append('device', 'web');	
			axios.post(API_URL+'/app/verifyotp-login', data, axiosHeader)
			.then((response) => {
				///console.log("RESPONSE RECEIVED: ", response);
				if(response && response.data && response.data.responseTxt==="success"){	
					///window.location.href = "logindirect?loginKey="+response.data.token;

					Cookies.set("accountDetails", JSON.stringify({
						sid: response?.data?.obj?.sid,
						studentId: response?.data?.obj?.studentId,
						loginId: response?.data?.obj?.loginId,
						token: response?.data?.obj?.token,
						studentName: response?.data?.obj?.studentName,
						mobile: response?.data?.obj?.phoneNo,
						email: response?.data?.obj?.emailId
					}))

					Cookies.set("token", `"${response?.data?.token}"`);
					localStorage.setItem("etlStudentObj", JSON.stringify(response.data.obj));
					
					if(response.data.obj.openedCourse!=null && response.data.obj.openedCourse>0){
						localStorage.setItem("etlSelectCourse", response.data.obj.openedCourse);
					}else{
						localStorage.setItem("etlSelectCourse", 0);
					}

					document.getElementById('waitloginbtnid').style.display='none';
					document.getElementById('loginbtnid').style.display='';

					if(response.data.obj.courses && response.data.obj.courses.length>0){
						// Set cookie accountDetails to login on website
						// Cookies.set("accountDetails", JSON.stringify({
						// 	sid: response?.data?.obj?.sid,
						// 	studentId: response?.data?.obj?.studentId,
						// 	loginId: response?.data?.obj?.loginId,
						// 	token: response?.data?.obj?.token,
						// 	studentName: response?.data?.obj?.studentName,
						// 	mobile: response?.data?.obj?.phoneNo,
						// 	email: response?.data?.obj?.emailId
						// }))

						// Set cookie token for the use on website
						// Cookies.set("token", `"${response?.data?.token}"`)

						// localStorage.setItem("etlStudentObj", JSON.stringify(response.data.obj));
						localStorage.setItem("etlMyCourses", JSON.stringify(response.data.obj.courses));
						
						// if(response.data.obj.openedCourse!=null && response.data.obj.openedCourse>0){
						// 	localStorage.setItem("etlSelectCourse", response.data.obj.openedCourse);
						// }else{
						// 	localStorage.setItem("etlSelectCourse", 0);
						// }

						// document.getElementById('waitloginbtnid').style.display='none';
						// document.getElementById('loginbtnid').style.display='';
						history.push("dashboard");

					}else{
						localStorage.setItem("etlMyCourses", []);
						// document.getElementById('waitloginbtnid').style.display='none';
						// document.getElementById('loginbtnid').style.display='';
						// setShowAlert(true);
						// setAlertMessage("Something wrong, Please contact to admin");
						window.location.href = "selectyourcourse";			
						return false;
					}

				}else if(response.data.responseTxt=="invalid_otp"){
					document.getElementById('waitloginbtnid').style.display='none';
					document.getElementById('loginbtnid').style.display='';
					setShowAlert(true);
					setAlertMessage("OTP is invalid");			
					return false;	
				}else{
					document.getElementById('waitloginbtnid').style.display='none';
					document.getElementById('loginbtnid').style.display='';
					setShowAlert(true);
					setAlertMessage("Something wrong, Try after sometime.");			
					return false;
				}
			})
			.catch((error) => {
				console.log("AXIOS ERROR: ", error);
			})
		}  
	}
	
	// function onEnter(event){
	// 	if(event.key === 'Enter'){
	// 		verify();
	// 	}
	// }

	function numberOnly(event){
		if (!/[0-9]/.test(event.key)) {
			event.preventDefault();
		} 
	}

		return (
			<div> 
				<MetaTags>
            		<title>Verify OTP | EaseTolearn MY Study Room & Exam Prep</title>
            		<meta name="description" content="Verify OTP | EaseTolearn MY Study Room & Exam Prep" />
          		</MetaTags>
				
				<Box className="loginBGImg" style={{backgroundImage:"url('"+process.env.PUBLIC_URL+"/student_login_bg.jpg')", backgroundPosition: 'center', height: '100vh', overflow: 'hidden'}}>					
						<Stack spacing={2} sx={{ width: '100%' }}>
							<Snackbar open={showAlert} autoHideDuration={6000} onClose={hideAlert} anchorOrigin={{vertical,horizontal}}  >
								<Alert onClose={hideAlert} variant="filled" severity="error" sx={{ width: '100%' }}>
									{alertMessage}
								</Alert>
							</Snackbar>
						</Stack>

					<Box>
						<Grid container style={{justifyContent: 'center'}} spacing={2}>
							<Grid item className="dhslogin" md={6} xs={12}>
							
								<Grid className="flex-container loginbox">								
									<Grid md={12} xs={12}>
										<img src={process.env.PUBLIC_URL+"/ease_to_learn_logo-white.png"} style={{height:80,marginTop:20,marginBottom:20}}  />
									</Grid>
									<Grid md={12} xs={12}>
										<div className='loginLabel' >Enter your OTP</div>
										<TextField 
											placeholder={'Enter your OTP'}
											inputProps={{maxLength: 6 }} 
											onKeyPress={(event)=>{numberOnly(event)}}
											onChange={event => setOtpNumber(event.target.value)}
											style={{backgroundColor:'#FFF', borderRadius: 5}}
											color="warning"
											size="small"
											fullWidth	
											variant="outlined"
										/>
									</Grid>
									<Grid md={12} xs={12} style={{marginTop: -25}} >
										<Button id="loginbtnid" onClick={()=>{verify()}} className="loginbtn" variant="contained">Verify OTP</Button>
										<LoadingButton 
											className="loginbtn"
											loading
											loadingPosition="start"											
											variant="outlined"
											color="secondary"
											id="waitloginbtnid" 
											style={{textTransform: 'none',display:'none'}}
										>
											Wait...
										</LoadingButton>
									</Grid>

								
								</Grid>
							

							</Grid>
											

						</Grid>
					</Box>




				</Box>
				
			</div>
		);
 
}